import DefaultVue from 'vue';
import { toCamelCase } from '../string';
const defaultStrat = (parentVal, childVal) => childVal === undefined ? parentVal : childVal;

/**
 * 这是一个很黑科技的东西，可以为一个 Vue 实例额外注入一些 method、data 之类的。
 * 相当于 Vue.extend(xxx) 的效果，但是是动态的，直接作用在组件实例
 *
 * 【注意】 仅限在组件 beforeCreate 时使用
 *
 * 功能类似 vue 的 mergeOptions，但是会读取全局注册的 Vue.config.optionMergeStrategies，从而能够支持到 router 生命周期之类的东西
 */
export function patchVueInstance(vm, options, Vue = DefaultVue) {
  if (!options) return;
  const deflated = {
    ...options
  };
  if (deflated.props) deflated.props = normalizeProps(deflated.props);
  if (deflated.inject) deflated.inject = normalizeInject(deflated.inject);
  const dst = vm.$options;
  const strats = Vue.config.optionMergeStrategies;
  Object.keys(deflated).forEach(key => {
    const strat = strats[key] || defaultStrat;
    dst[key] = strat(dst[key], deflated[key], vm, key);
  });

  // 执行额外的 beforeCreate

  if (typeof deflated.beforeCreate === 'function') deflated.beforeCreate.call(vm);
}

// 下面的方法是取自 vue 未暴露的内部方法

function normalizeProps(raw) {
  if (!raw) return {};
  if (Array.isArray(raw)) {
    // 支持 ['xxx', 'yyy'] 的写法
    const ans = {};
    raw.forEach(n => {
      const name = toCamelCase(n);
      ans[name] = {
        type: null
      };
    });
    return ans;
  }
  if (typeof raw === 'object') {
    // 转换 {'kebab-case': xxx} 为 {'camelCase': xxx}
    const ans = {};
    Object.keys(raw).forEach(n => {
      const name = toCamelCase(n);
      ans[name] = raw[n];
    });
    return ans;
  }
  console.warn('Invalid props: ', raw);
  return {};
}
function normalizeInject(raw) {
  if (!raw) return {};
  if (Array.isArray(raw)) {
    // 支持 ['xxx', 'yyy'] 的写法
    const ans = {};
    raw.forEach(n => {
      const name = toCamelCase(n);
      ans[name] = {
        from: name
      };
    });
    return ans;
  }
  if (typeof raw === 'object') {
    // 转换 {'kebab-case': xxx} 为 {'camelCase': xxx}
    const ans = {};
    Object.keys(raw).forEach(n => {
      const name = toCamelCase(n);
      ans[name] = {
        from: name,
        ...raw[n]
      };
    });
    return ans;
  }
  console.warn('Invalid inject: ', raw);
  return {};
}
//# sourceMappingURL=patchVueInstance.js.map
